import React from "react";
import PropTypes from "prop-types";
import Modal2 from "./modal-2";
import useOpenClose from "../../hooks/use-open-close";

const ModalTrigger2 = ({
  contentClassName,
  overlayClassName,
  trigger,
  children,
  contentStyle,
  overlayStyle,
  transitionProps,
  disableAnimation,
  ...rest
}) => {
  const [is_open, open, close] = useOpenClose(false);
  return (
    <React.Fragment>
      {trigger({
        is_open,
        close,
        open,
      })}
      <Modal2
        onClose={close}
        isOpen={is_open}
        contentClassName={contentClassName}
        overlayClassName={overlayClassName}
        overlayStyle={overlayStyle}
        contentStyle={contentStyle}
        transitionProps={transitionProps}
        disableAnimation={disableAnimation}
        {...rest}
      >
        {typeof children === "function" ? children({ close }) : children}
      </Modal2>
    </React.Fragment>
  );
};

ModalTrigger2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  contentClassName: PropTypes.string,
  overlayClassName: PropTypes.string,
  trigger: PropTypes.func.isRequired,
  contentStyle: PropTypes.object,
  overlayStyle: PropTypes.object,
  transitionProps: PropTypes.object,
  disableAnimation: PropTypes.bool,
};

export default ModalTrigger2;
